import { ConsentPolicy } from '@wix/wix-bootstrap-api';
import React, { createContext, FC, PropsWithChildren } from 'react';
import { Template } from '../domain/entities/template';
import { AppSpecs } from '../experiments/appSpecs';
import { Book } from '../domain/entities/book';
import { InspirationalTemplate } from '../domain/entities/inspirationalTemplate';

type LoggedInUserData = {
  isLoggedIn: true;
  profile: {
    id: string;
    isStudioAccount: boolean;
    image?: {
      imageUrl: string;
    };
    name?: {
      first?: string;
      last?: string;
    };
  };
};

type LoggedOutUserData = {
  isLoggedIn: false;
};

export type UserData = LoggedInUserData | LoggedOutUserData;

export interface InitialState {
  isMobile: boolean;
  book: Book;
  templates: Template[];
  totalTemplatesCount: number;
  criteria?: string;
  inspirationalTemplates: InspirationalTemplate[];
  categoryId?: string;
  referrer?: string;
  baseUrl: string;
  userData: UserData;
  locale: string;
  consentPolicy?: ConsentPolicy;
  appSpecs: AppSpecs;
}

interface InitialStateProviderProps {
  initialState: InitialState;
}

const InitialStateContext = createContext<InitialState | null>(null);
export const InitialStateProvider: FC<
  PropsWithChildren<InitialStateProviderProps>
> = ({ initialState, children }) => {
  return (
    <InitialStateContext.Provider value={initialState}>
      {children}
    </InitialStateContext.Provider>
  );
};

export const useInitialState = () => {
  const context = React.useContext(InitialStateContext);
  if (!context) {
    throw new Error(
      'useInitialState must be used within a InitialStateProvider',
    );
  }

  return context;
};
